import { SectionHeadingProps, TextSectionProps } from '@brick/ui-components';

export const realityServiceTextContent: TextSectionProps = {
  textWithHeading: {
    heading: {
      title: 'REALITA V REALITÁCH',
    },
    content: `Spoločnosť BRICK reality vznikla so zámerom zlepšenia realitného trhu. Keďže mnohé realitné kancelárie robia nekvalitnú robotu a zlé meno realitnej službe, nečudujeme sa, že klienti realitkám neveria a radšej si riešia predaj nehnuteľnosti po svojom.
    <br>Dnešná doba ponúka toľko možností robiť veci lepšie, avšak prístup väčšiny realitných kancelárií zostal v minulom tisícročí. Treba však povedať, že realitné kancelárie nie sú jediné, ktoré nesú vinu. Istou mierou k súčasnému stavu realitného trhu prispievajú samotní majitelia nehnuteľností. Ak dovolia inzerovať jednu nehnuteľnosť viacerým realitným kanceláriám pri použití fotiek majiteľa, a zároveň očakávajú konkurenčný boj, tak dosiahnu pravý opak. 
    <br>RK neprejaví veľkú snahu pri predaji nehnuteľnosti a ešte aj za to málo si vypýta nezaslúženú províziu. Maklér v danom prípade vôbec nepracuje v prospech majiteľa nehnuteľnosti! Častokrát je práve na strane kupujúceho, aby rýchlo predal a zmanipuloval predávajúceho. Bežne sa stáva, že maklér vidí nehnuteľnosť a majiteľa prvýkrát až s prvým kupujúcim, ktorý je zhrozený, že maklér o danej nehnuteľnosti nič nevie a stav, ktorý bol inzerovaný nezodpovedá skutočnosti.
    <br>Úprimne sme sklamaní, ak klienti nevyťažia zo svojej nehnuteľnosti maximum. Ak ste sa dostali až sem, ste na dobrej ceste spraviť správne rozhodnutie. 
    `,
    color: 'grey.500',
  },
};

export const sellImageTextContent = {
  image: '/other/keys.png',
  content: `
  ## Na čo sa pripraviť pri predaji / prenájme

  Ak plánujete ponúkať svoju nehnuteľnosť na vlastnú päsť, treba mať vysporiadanú nehnuteľnosť, vytvoriť inzerát, vytvoriť fotografie, napísať popis. 
  <br>Po zverejnení inzerátu Vás čaká celý rad maklérov, čo Vám budú volať. Nebudete mať prehľad o reálnom dopyte záujemcov, čím stratíte čas aj peniaze.

## Aký prístup môžete očakávať u nás?

- vždy máme stretnutie s majiteľom nehnuteľnosti a vypočujeme si jeho očakávania
- vidíme reálny stav nehnuteľnosti, vypracujeme cenovú analýzu a prejdeme ju s majiteľom
- odborne pristupujeme k inzercii pri využití rôznych technológií
- obhájime si inzerovanú cenu, efektívne obhliadky a v prípade viacerých záujemcov licitujeme
- právna podpora a finančné poradenstvo sú u nás samozrejmosťou
  `,
};

export const realityServiceImageTextContent = {
  image: '/other/house.png',
  content: `
  ## Na čo sa pripraviť pri kúpe / prenájme
  <br>
  Pravdepodobne by ste si hneď chceli dohodnúť obhliadku. Častokrát sú v inzerátoch nepresné informácie, a preto si najskôr zistite všetky dôležité skutočnosti vopred, či spĺňajú Vami požadované kritériá. Až potom si dohadujte obhliadku. Ušetríte tak veľa svojho času. Pri skutočne vážnych obhliadkach si dajte pozor na skryté závady a nedostatky.
  
  <br>
  <br>
  
  Ak ste práve zistili, že by to bolo nad Vaše schopnosti, využite naše služby. Nechajte všetku prácu na odborníkovi, ktorý dohliadne na celý proces od začiatku až do konca.
  
  ## Aký prístup môžete očakávať u nás?
  
  - bezplatná konzultácia s naším realitným maklérom
  - služba na základe uzavretej zmluvy
  - maklér vyhľadá aktívne aj neoficiálne ponuky, nečaká na náhody
  - maklér sa snaží vyjednať cenu nadol
  - právna podpora v jednotlivých prípadoch
  `,
};

export const buyImageTextContent = {
  image: '/other/house.png',
  content: `
  ## Na čo sa pripraviť pri kúpe / prenájme
  <br>
  Kto by nechcel svoje vysnívané bývanie? Čo ak ste už videli všetky inzeráty a konečne ste si vybrali podľa popisu a fotiek vyhovujúcu nehnuteľnosť. Zavoláte na priložené číslo a nikto neberie. O pár hodín Vám volá maklér, v lepšom prípade majiteľ. Na čo sa budete pýtať? 

  <br>Ak ste práve zistili, že by to bolo nad Vaše schopnosti, využite naše služby. Nechajte všetku prácu na odborníkovi, ktorý dohliadne na celý proces od začiatku až do konca.
  
  ## Aký prístup môžete očakávať u nás?
  
  - bezplatná konzultácia s naším realitným maklérom
  - služba na základe uzavretej zmluvy
  - maklér vyhľadá aktívne aj neoficiálne ponuky, nečaká na náhody
  - maklér sa snaží vyjednať cenu nadol
  - právna podpora v jednotlivých prípadoch
  `,
};

export const realityServicePerksSectionHeading: SectionHeadingProps = {
  title: 'REALITNÝ SERVIS NA PROFESIONÁLNEJ ÚROVNI',
  description:
    'Čo tak vyložiť si nohy a mať istotu, že všetko ide podľa plánu? S BRICK reality je predaj, alebo kúpa nehnuteľnosti bez komplikácií.',
  textAlign: 'left',
  alignItems: 'flex-start',
};
